import * as React from 'react';
import { storiesOf } from '@storybook/react';
import { VisualTestContainer } from '../../test/visual/VisualTestContainer';
import { Ratings, RatingsMode, RatingsSize } from '..';
import { RatingsLabelPlacement, RatingsLayout } from './types';
import { classes } from './Ratings.visual.st.css';
import { ErrorAppearance } from '../internal/ErrorMessageWrapper';

const errorMessage = 'This is an error message';
const getElementFromBelow = () => {
  return (
    <div className={classes.elementBelow}>
      An element below to show the spacing
    </div>
  );
};

class RatingsVisual extends React.Component<any> {
  static defaultProps = {
    hook: null,
  };

  render() {
    const ratingsProps = { ...this.props };
    delete ratingsProps.hook;
    return (
      <VisualTestContainer>
        <Ratings {...ratingsProps} />
        {ratingsProps.error &&
          ratingsProps.errorMessage &&
          getElementFromBelow()}
      </VisualTestContainer>
    );
  }
}

class RatingsVisualFloat extends React.Component<any> {
  static defaultProps = {
    hook: null,
  };

  render() {
    const ratingsProps = { ...this.props };
    delete ratingsProps.hook;
    return (
      <VisualTestContainer>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <Ratings value={3.0} {...ratingsProps} />
          <Ratings value={3.1} {...ratingsProps} />
          <Ratings value={3.2} {...ratingsProps} />
          <Ratings value={3.3} {...ratingsProps} />
          <Ratings value={3.4} {...ratingsProps} />
          <Ratings value={3.5} {...ratingsProps} />
          <Ratings value={3.6} {...ratingsProps} />
          <Ratings value={3.7} {...ratingsProps} />
          <Ratings value={3.8} {...ratingsProps} />
          <Ratings value={3.9} {...ratingsProps} />
        </div>
      </VisualTestContainer>
    );
  }
}

const tests = [
  {
    describe: 'basic',
    its: [
      {
        it: 'default',
        props: {},
      },
      {
        it: 'disabled',
        props: {
          disabled: true,
        },
      },
      {
        it: 'error',
        props: {
          error: true,
        },
      },
      {
        it: 'new error message',
        props: {
          error: true,
          errorMessage,
        },
      },
      {
        it: 'new error message / ErrorAppearance - BackgroundAndBorder',
        props: {
          errorAppearance: ErrorAppearance.BackgroundAndBorder,
          error: true,
          errorMessage,
        },
      },
      {
        it: 'new error message with override styles',
        props: {
          error: true,
          errorMessage,
          className: classes.root,
        },
      },
      {
        it: 'new error message with override styles / ErrorAppearance - BackgroundAndBorder',
        props: {
          errorAppearance: ErrorAppearance.BackgroundAndBorder,
          error: true,
          errorMessage,
          className: classes.root,
        },
      },
      {
        it: 'display mode',
        props: {
          value: 3,
          mode: RatingsMode.Display,
        },
      },
      {
        it: 'Large Size',
        props: {
          value: 3,
          mode: RatingsMode.Display,
          size: RatingsSize.Large,
        },
      },
      {
        it: 'Input Options',
        props: {
          mode: RatingsMode.Input,
          size: RatingsSize.Large,
          inputOptions: ['Very baasa', 'Baasa', 'OK', 'Magniv', 'Achla'],
        },
      },
      {
        it: 'Input Options with Initial value',
        props: {
          value: 3,
          mode: RatingsMode.Input,
          size: RatingsSize.Large,
          inputOptions: ['Very baasa', 'Baasa', 'OK', 'Magniv', 'Achla'],
        },
      },
      {
        it: 'Input Options bottom',
        props: {
          value: 3,
          mode: RatingsMode.Input,
          layout: RatingsLayout.Bottom,
          inputOptions: ['Very baasa', 'Baasa', 'OK', 'Magniv', 'Achla'],
        },
      },
      {
        it: 'count info & rating info',
        props: {
          value: 3,
          mode: RatingsMode.Display,
          countDisplay: '150',
          ratingDisplay: '3.0',
        },
      },
      {
        it: 'should show half-stars',
        props: {
          mode: RatingsMode.Display,
        },
        Component: RatingsVisualFloat,
      },
      {
        it: 'should show large half-stars',
        props: {
          mode: RatingsMode.Display,
          size: RatingsSize.Large,
        },
        Component: RatingsVisualFloat,
      },

      {
        it: 'with label on top',
        props: {
          value: 3,
          mode: RatingsMode.Input,
          label: 'Rate Us',
        },
      },
      {
        it: 'with label on top and input options aside',
        props: {
          value: 3,
          mode: RatingsMode.Input,
          label: 'Rate Us',
          inputOptions: ['Very baasa', 'Baasa', 'OK', 'Magniv', 'Achla'],
        },
      },
      {
        it: 'with label on top and input options at bottom',
        props: {
          value: 3,
          mode: RatingsMode.Input,
          layout: RatingsLayout.Bottom,
          label: 'Rate Us',
          inputOptions: ['Very baasa', 'Baasa', 'OK', 'Magniv', 'Achla'],
        },
      },
      {
        it: 'with label aside',
        props: {
          value: 3,
          mode: RatingsMode.Input,
          label: 'Rate Us',
          labelPlacement: RatingsLabelPlacement.Aside,
        },
      },
      {
        it: 'with label aside and input options aside',
        props: {
          value: 3,
          mode: RatingsMode.Input,
          label: 'Rate Us',
          labelPlacement: RatingsLabelPlacement.Aside,
          inputOptions: ['Very baasa', 'Baasa', 'OK', 'Magniv', 'Achla'],
        },
      },
      {
        it: 'big with label on top',
        props: {
          size: RatingsSize.Large,
          value: 3,
          mode: RatingsMode.Input,
          label: 'Rate Us',
        },
      },
      {
        it: 'big with label on top and input options aside',
        props: {
          size: RatingsSize.Large,
          value: 3,
          mode: RatingsMode.Input,
          label: 'Rate Us',
          inputOptions: ['Very baasa', 'Baasa', 'OK', 'Magniv', 'Achla'],
        },
      },
      {
        it: 'big with label on top and input options at bottom',
        props: {
          size: RatingsSize.Large,
          value: 3,
          mode: RatingsMode.Input,
          layout: RatingsLayout.Bottom,
          label: 'Rate Us',
          inputOptions: ['Very baasa', 'Baasa', 'OK', 'Magniv', 'Achla'],
        },
      },
      {
        it: 'big with label aside',
        props: {
          size: RatingsSize.Large,
          value: 3,
          mode: RatingsMode.Input,
          label: 'Rate Us',
          labelPlacement: RatingsLabelPlacement.Aside,
        },
      },
      {
        it: 'big with label aside and input options aside',
        props: {
          size: RatingsSize.Large,
          value: 3,
          mode: RatingsMode.Input,
          label: 'Rate Us',
          labelPlacement: RatingsLabelPlacement.Aside,
          inputOptions: ['Very baasa', 'Baasa', 'OK', 'Magniv', 'Achla'],
        },
      },
      {
        it: 'wst override',
        props: {
          size: RatingsSize.Large,
          value: 3,
          mode: RatingsMode.Input,
          label: 'Rate Us',
          labelPlacement: RatingsLabelPlacement.Aside,
          inputOptions: ['Very baasa', 'Baasa', 'OK', 'Magniv', 'Achla'],
          className: classes.wstStyled,
        },
      },
    ],
  },
];

tests.forEach(({ describe, its }) => {
  its.forEach(({ it, props, Component = RatingsVisual }) => {
    storiesOf(`Ratings/${describe}`, module).add(it, () => (
      <Component {...props} />
    ));
  });
});
